var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V9.34625C0 20.5487 9.4775 24.2638 11.375 24.8937C11.7801 25.0324 12.2199 25.0324 12.625 24.8937C14.525 24.2625 24 20.5475 24 9.345V2C24 1.46957 23.7893 0.960859 23.4142 0.585786C23.0391 0.210714 22.5304 0 22 0ZM22 9.34875C22 19.1512 13.7075 22.4263 12 22.9963C10.3088 22.4338 2 19.1613 2 9.34875V2H22V9.34875ZM11 12V7C11 6.73478 11.1054 6.48043 11.2929 6.29289C11.4804 6.10536 11.7348 6 12 6C12.2652 6 12.5196 6.10536 12.7071 6.29289C12.8946 6.48043 13 6.73478 13 7V12C13 12.2652 12.8946 12.5196 12.7071 12.7071C12.5196 12.8946 12.2652 13 12 13C11.7348 13 11.4804 12.8946 11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12ZM10.5 16.5C10.5 16.2033 10.588 15.9133 10.7528 15.6666C10.9176 15.42 11.1519 15.2277 11.426 15.1142C11.7001 15.0007 12.0017 14.9709 12.2926 15.0288C12.5836 15.0867 12.8509 15.2296 13.0607 15.4393C13.2704 15.6491 13.4133 15.9164 13.4712 16.2074C13.5291 16.4983 13.4993 16.7999 13.3858 17.074C13.2723 17.3481 13.08 17.5824 12.8334 17.7472C12.5867 17.912 12.2967 18 12 18C11.6022 18 11.2206 17.842 10.9393 17.5607C10.658 17.2794 10.5 16.8978 10.5 16.5Z",
    fill: "#F1760F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.2fdc362c.svg";
export { ForwardRef as ReactComponent };